/*
  После инициализации класса, необходимо вызывать метод setUuid() и передеать аргументом uuid сущности

  Пример использования:
  *****************

  const options = new Options({
    type: 'counterparty',
    routeName: 'counterparty',
    formSuccessMessage: 'Данные контрагента успешно изменены.',
    deleteFormSuccessMessage: 'Контрагент успешно удален.',
    deleteFormTitle: 'Вы действительно хотите удалить данного контрагента?'
    unDeleteFormTitle: 'Уверены, что хотите восстановить данного контрагента?'
  })

  options.setUuid(uuid)

  *****************
*/
import { AccessClass } from './accessClass'

// Специальная функция - заглушка.
const noop = async () => { }

export class Options {
  config: {
    addAction: string
    editAction: string
    viewAction: string
    adapter: string,
    type: string,
    deleteType: string,
    entitiesListShow: boolean
    _params?: unknown
  }

  subConfig: {
    addAction: string
    editAction: string
    adapter: string,
    type: string,
    deleteType: string,
    goto: string
  }

  modalForm: {
    uuid: string,
    title: string,
    type: string
  }

  viewName: string
  viewNameTaxonomyTerms: string
  bundleType: string
  bundleTypeTaxonomyTerm: string

  uuid: string = ''
  contractorUuid: string = ''
  employeeUuid: string = ''
  yearMonth: string = ''
  workplaceUuid: string = ''
  goto: string = ''
  formURL: string
  refreshURL: string
  formMethod: string
  saveRequestType: 'form' | 'json'
  formSuccessMessage: string

  addFormSuccessMessage: string

  getVersionURL: string
  getVersionMethod: string

  setVersion: {
    URL: string
    method: string
    successMessage: string
    setButtonTitle: string
    closeModalButtonTitle: string
    previewButtonTitle: string
  }

  access: AccessClass = new AccessClass({})

  deleteFormSuccessMessage: string
  deleteFormTitle: string
  unDeleteFormTitle: string

  unPublicFormTitle: string
  publicFormTitle: string
  unPublicButtonTitle: string
  publicButtonTitle: string
  unPublicAction: Function = async () => { }
  publicAction:  Function = async () => { }

  routeName: string
  entityRouteName: string
  entityRouteParams: Record<string, unknown>
  baseURL: string

  listButtonText: string
  addButtonText: string
  saveButtonText: string
  updateCourse: string
  export: string

  documentTitle: string

  params: any

  titleKey: string

  customTabs: boolean

  constructor (data: Record<string, any>) {
    this.config = {
      addAction: 'add',
      viewAction: data?.config?.viewAction ?? 'view',
      editAction: data?.config?.editAction ?? 'edit',
      adapter: data?.config?.adapter ?? 'Node',
      type: data?.type,
      deleteType: data?.bundleType !== undefined ? data?.bundleType : 'node',
      entitiesListShow: data?.config?.entitiesListShow || false
    }

    this.subConfig = {
      addAction: 'add',
      editAction: 'edit',
      adapter: data?.subConfig?.adapter || 'Node',
      type: data?.subConfig?.type,
      deleteType: data?.bundleType || 'node',
      goto: data?.subConfig?.goto || ''
    }

    this.modalForm = {
      uuid: data?.modalForm?.uuid,
      title: data?.modalForm?.title,
      type: data?.modalForm?.type
    }

    this.saveButtonText = data?.saveButtonText || 'Сохранить'
    this.addButtonText = data?.addButtonText || 'Добавить'
    this.listButtonText = data?.listButtonText || 'Список'
    this.updateCourse = data?.updateCourse || 'Обновить курсы из СДО UCHI.PRO'
    this.export = data?.export || 'Экспорт'

    this.viewName = data?.viewName || ''
    this.viewNameTaxonomyTerms = data?.viewNameTaxonomyTerms || ''
    this.bundleType = data?.bundleType || ''
    this.bundleTypeTaxonomyTerm = data?.bundleTypeTaxonomyTerm || ''
    this.formURL = data?.formURL || '/api/node/set'
    this.refreshURL = data?.refreshURL || '/api/node/field/refresh'
    this.formMethod = 'POST'
    this.saveRequestType = data?.saveRequestType || 'form'
    this.getVersionURL = '/api/node/version/get'
    this.getVersionMethod = 'POST'

    this.setVersion = {
      URL: '/api/node/version/set',
      method: 'POST',
      successMessage: data?.setVersion?.setVersionSuccessMessage || 'Версия успешно установлена',
      setButtonTitle: data?.setVersion?.setButtonTitle || 'Установить',
      closeModalButtonTitle: data?.setVersion?.closeModalButtonTitle || 'Закрыть',
      previewButtonTitle: data?.setVersion?.previewButtonTitle || 'Предпросмотр'
    }

    this.formSuccessMessage = data?.formSuccessMessage || 'Запись успешно изменена.'
    this.addFormSuccessMessage = data?.addFormSuccessMessage || 'Запись успешно добавлена'

    this.routeName = data?.routeName
    this.entityRouteName = data?.entityRouteName || ''
    this.entityRouteParams = data?.entityRouteParams || {}
    this.baseURL = '/directory/' + data?.routeName

    this.deleteFormSuccessMessage = data?.deleteFormSuccessMessage || 'Запись успешно удалена.'
    this.deleteFormTitle = data?.deleteFormTitle || 'Вы действительно хотите удалить данную запись?'
    this.unDeleteFormTitle = data?.unDeleteFormTitle || 'Уверены, что хотите восстановить эту запись?'

    this.unPublicFormTitle = data?.unPublicFormTitle || 'Уверены, что хотите снять с публикации эту запись?'
    this.publicFormTitle = data?.publicFormTitle || 'Уверены, что хотите опубликовать эту запись?'
    this.unPublicButtonTitle = data?.unPublicButtonTitle || 'Снять с публикации'
    this.publicButtonTitle = data?.publicButtonTitle || 'Опубликовать'
    this.unPublicAction = data?.unPublicAction || noop
    this.publicAction = data?.publicAction || noop

    this.params = data?.params || null

    this.documentTitle = data?.documentTitle || ''

    this.titleKey = data?.titleKey

    this.customTabs = data?.customTabs || false

    if (data?.uuid) {
      this.setUuid(data.uuid)
    }
  }

  setUuid (uuid: string | null) {
    this.uuid = uuid ?? ''
  }

  setEntityRouteParams (params: Record<string, unknown>) {
    this.entityRouteParams = params
  }

  setContractorUuid (contractorUuid: string | null) {
    this.contractorUuid = contractorUuid ?? ''
  }

  setEmployeeUuid (employeeUuid: string | null) {
    this.employeeUuid = employeeUuid ?? ''
  }

  setWorkplaceUuid (workplaceUuid: string) {
    this.workplaceUuid = workplaceUuid
  }

  setYearMonth (yearMonth: string) {
    this.yearMonth = yearMonth
  }

  setGoTo (goto: string) {
    this.goto = goto
  }

  setAccess (data: ConstructorParameters<typeof AccessClass>[0]) {
    this.access = new AccessClass(data)
  }

  getEditConfig (filter?: Record<string, unknown>) {
    return this.getEntityConfig(this.config.editAction, filter)
  }

  getViewConfig (filter?: Record<string, unknown>) {
    return this.getEntityConfig(this.config.viewAction, filter)
  }

  private getEntityConfig (action: string, filter?: Record<string, unknown>) {
    const config: any = {
      __action: action,
      __adapter: this.config.adapter,
      __params: this.params
        ? this.params
        : {
            Defaults: Object.assign({
              uuid: this.uuid,
            }, filter || {})
          },
      __uuid: this.uuid
    }

    if (this.config.type) {
      config.__type = this.config.type
    }

    return config
  }

  getAddConfig (filter?: Record<string, unknown>) {
    return {
      __action: this.config.addAction,
      __adapter: this.config.adapter,
      __params: this.params
        ? this.params
        : {
            Defaults: Object.assign({
              uuid: this.uuid,
              ContractorUuid: this.contractorUuid,
              EmployeeUuid: this.employeeUuid,
              WorkplaceUuid: this.workplaceUuid,
              YearMonth: this.yearMonth,
              goto: this.goto
            }, filter || {})
          },
      __type: this.config.type,
      __uuid: this.uuid || ''
    }
  }

  getMedExamConfig () {
    return {
      __action: this.subConfig.addAction,
      __adapter: this.subConfig.adapter,
      __params: {
        Defaults: {
          goto: this.subConfig.goto
        }
      },
      __type: this.subConfig.type,
      __uuid: this.uuid || ''
    }
  }

  getConfig () {
    return {
      __adapter: this.config.adapter,
      __type: this.config.type,
      __uuid: this.uuid
    }
  }
}
